import type { ReactNode } from 'react';
import styles from './PaymentNoticeBanner.module.css';

export interface PaymentNoticeBannerProps {
	icon: ReactNode;
	children: ReactNode;
	tone?: 'info' | 'error';
}

export const PaymentNoticeBanner = ({ icon, children, tone = 'info' }: PaymentNoticeBannerProps) => {
	return (
		<div className={`${styles.wrapper} ${styles[tone]}`}>
			<span className={styles.icon}>{icon}</span>
			<span className={styles.text}>{children}</span>
		</div>
	);
};
